import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import Splashscreen from './components/progress/Splashscreen';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const App = lazy(() => import('./App'));

root.render(
  <React.StrictMode>
    <Suspense fallback={<Splashscreen />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
